// extracted by mini-css-extract-plugin
export default {"button":"button_button__rr3yo","primary":"button_primary__ZKyxA","secondary":"button_secondary__BW4TH","icon":"button_icon__wR69X","loadingIcon":"button_loadingIcon__RQ3qr"};